import Home from "./container/deca.home";
import RegistrarSolicitacao from "./container/deca.registrarsolicitacao";
import RetificarSolicitacao from "./container/deca.retificarsolicitacao";
import ValidacaoSolicitacao from "./components/validaSolicitacao/container/deca.validacaosolicitacao";
import ConsultaSolicitacao from "./components/consultaSolicitacao/container/deca.consultasolicitacao";
import Comprovante from "./components/comprovante/container/comprovanteSolicitacao";

const routes = [
  {
    name: "DECA",
    path: "/deca",
    component: Home,
    breadCrumb: [{ text: "DECA" }],
  },
  {
    name: "deca.registrarsolicitacao",
    path: "/deca/registrarsolicitacao",
    component: RegistrarSolicitacao,
    breadCrumb: [{ text: "DECA", link: "deca" }, { text: "Registrar" }],
  },
  {
    name: "deca.retificarsolicitacao",
    path: "/deca/retificarsolicitacao/:id",
    component: RetificarSolicitacao,
    breadCrumb: [
      { text: "DECA", link: "deca" },
      { text: "Consultar / Retificar" },
    ],
  },
  {
    name: "deca.consultasolicitacao",
    path: "/deca/consultasolicitacao",
    component: ConsultaSolicitacao,
    breadCrumb: [
      { text: "DECA", link: "deca" },
      { text: "Consultar / Retificar Solicitação" },
    ],
  },
  {
    name: "deca.validacaosolicitacao",
    path: "/deca/validacaosolicitacao",
    component: ValidacaoSolicitacao,
    breadCrumb: [
      { text: "DECA", link: "deca" },
      { text: "Validação de Solicitação" },
    ],
  },
  {
    name: "deca.comprovantesolicitacao",
    path: "/deca/comprovanteSolicitacao/:id",
    component: Comprovante,
    breadCrumb: [
      { text: "DECA", link: "deca" },
      { text: "Validação de Solicitação" },
    ],
  },
];

export default routes;
